var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"products-archive__section-wrapper"},[_c('div',{staticClass:"uk-grid",attrs:{"uk-grid":""}},_vm._l((_vm.items),function(product){return _c('div',{staticClass:"uk-width-1-2@s uk-width-1-3@tablet uk-width-1-3@m uk-width-1-4@l"},[_c('product-card',{attrs:{"product":product}})],1)}),0)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb8747be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/ProductsDataGridResults.vue
// module id = McHi
// module chunks = 0